import '../App.css';
import Footer from './Footer';
import ProgressCheckout from './ProgressCheckout';
import TableCheckout from './TableCheckout';
import Swal from 'sweetalert2';
import Header from './Header';
import { useEffect, useState } from "react";


function FormDirection(){

    let p1 = 2;

    const [carrito, setCarrito] = useState([]);

    const [nombre, setNombre] = useState("");
    const [email, setEmail] = useState("");
    const [telefono, setTelefono] = useState("");
    const [calle, setCalle] = useState("");
    const [referencia, setReferencia] = useState("");
    const [ciudad, setCiudad] = useState("");
    const [sector, setSector] = useState("");

    const [direccion, setDireccion] = useState([]);


    const agregarDireccion=(name,gmail,phone,strett,ref,city,cities)=>{

        const registro = {
            Nombre: `${name}`,
            Email: `${gmail}`,
            Telefono: `${phone}`,
            Calle: `${strett}`,
            Referencia: `${ref}`,
            Ciudad: `${city}`,
            Sector: `${cities}`
        }

        setDireccion(registro)

    }


    useEffect(()=>{
        const storeProductos = JSON.parse(localStorage.getItem('Registrados'));
        const storeDireccion = JSON.parse(localStorage.getItem('Direccion'));
        if(storeProductos){
          setCarrito(storeProductos);
        }
        if(storeDireccion){
            setDireccion(storeDireccion);
        }
      }
    ,[])
    useEffect(()=>{
        localStorage.setItem('Direccion', JSON.stringify(direccion))
    }
    ,[direccion])

    let total=0;

    const sumall = carrito.map(item => item.Price);
    sumall.forEach(function(a){total+=a;});

    const redireccionar=()=>{
        window.location.href = '/'
    }

    const enviarDireccion=()=>{

        if(nombre==="" || email==="" || telefono==="" || calle==="" || referencia==="" || ciudad==="" || sector===""){
            Swal.fire(
                'Oops...',
                'Debe rellenar todos los campos!',
                'info'
            )
        }else{
            Swal.fire({
                title: 'Estas seguro que esta es tu direccion?',
                text: "Revisa bien tus datos ya que a esta direccion enviaremos tu pedido!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si enviar'
              }).then((result) => {
                if (result.isConfirmed) {
                   window.location.href = '/payment'
                   agregarDireccion(nombre,email,telefono,calle,referencia,ciudad,sector)
                }
            })
        }

    }

    return (
        <>
            
            <Header num={sumall.length}/>

            <div className="container-progress-checkout">
                <ProgressCheckout estilo={p1}/>
            </div>

            <div className="container-form-direction">

                <form method="" className="form-container">
                    <h2 className="form-title">Su dirección</h2>
                    <div className="checkout-form">

                        <div className="input-line">
                            <label for="name">Nombre</label>
                            <input type="text" name="name" id="name" placeholder="" required onChange={(e)=>setNombre(e.target.value)}/>
                        </div>

                        <div className="input-container">
                            <div className="input-line">
                                <label for="name">Email</label>
                                <input type="email" name="name" id="name" placeholder="" required onChange={(e)=>setEmail(e.target.value)}/>
                            </div>
                            <div className="input-line">
                                <label for="name">Telefono</label>
                                <input type="tel" name="name" id="name" placeholder="+1809" required onChange={(e)=>setTelefono(e.target.value)}/>
                            </div>
                        </div>

                        <div className="input-line">
                            <label for="name">Calle y Numero de casa</label>
                            <input type="text" name="name" id="name" placeholder="" required onChange={(e)=>setCalle(e.target.value)}/>

                            <label for="name" style={{ marginTop: '4px' }}>Referencias</label>
                            <input type="text" name="name" id="name" placeholder="" onChange={(e)=>setReferencia(e.target.value)}/>
                        </div>

                        <div className="input-container">
                            <div className="input-line">
                                <label for="name">Ciudad</label>
                                <input type="text" name="name" id="name" placeholder="" required onChange={(e)=>setCiudad(e.target.value)}/>
                            </div>
                            <div className="input-line">
                                <label for="name">Sector</label>
                                <input type="text" name="name" id="name" placeholder="" required onChange={(e)=>setSector(e.target.value)}/>
                            </div>
                        </div>

                        <input onClick={()=> enviarDireccion()} className='continuar-checkout' type="button" value="Continuar"></input>
                        {/* <i className="fa fa-chevron-right"></i> */}
                    </div>
                </form>

                <div className='table-form-direction'>
                    <table>
                        <thead>
                            <tr>
                                <th>Producto</th>
                                <th>Cantidad</th>
                                <th>Precio</th>
                            </tr>
                        </thead>
                        <tbody>
                            {carrito.map((c)=>{
                                return(
                                    <tr>
                                        <td>
                                            <img src={c.Image} alt="" /><br />
                                            {c.Title}
                                        </td>
                                        <td>1</td>
                                        <td>RD$ {c.Price}.00</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                        <thead>
                            <tr>
                                <th>Total</th>
                                <th>{sumall.length}</th>
                                <th>RD$ {total}.00</th>
                            </tr>
                        </thead>
                    </table>
                </div>

            </div>

            <Footer />

        </>
    )
}

export default FormDirection
